<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/PjVHWS/tc-custom/9781453205907.jpg?1734038406460" alt="This image is the cover for the book Problem of the Surly Servant, The Charles Dodgson and Arthur Conan Doyle Mysteries"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Problem of the Surly Servant, The Charles Dodgson and Arthur Conan Doyle Mysteries
      </h1>
      <p class="bookDescription body article font2">
        <b>At Oxford, a rash of crime puts Dodgson under suspicion of murder</b><br/><br/> The world of academia is hardly a hotbed of crime. And although scholars at the University of Oxford may debate the assassination of Caesar or the execution of Socrates, a modern criminal has no place within the school’s walls. And yet, as the reverend Charles Dodgson is horrified to learn, there is a thief within the college of Christ Church. The wine cellar has been ransacked, the faculty has been robbed, and a <a>female student is being threatened by a blackmailer.</a> It falls to Dodgson—better known as Lewis Carroll—to unmask the thief with the help of his dear friend Arthur Conan Doyle.<br/><br/> The campus crimes quickly escalate until the university’s hallowed halls are stained with blood. When suspicion of murder falls at Dodgson’s feet, it is up to Doyle to clear his friend’s name—with the brilliance and style befitting the man who created Sherlock Holmes.<br/>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Roberta Rogow
      </h2>
      
      <p class="authorDescription body article">Roberta Rogow (b. 1942) is an author of speculative fiction. A professional children&rsquo;s librarian, she began writing fan fiction in 1973 after a love of <I>Star Trek</I> lured her to her first science fiction convention. After several years publishing stories in fanzines, she founded <a><I>Grip</I></a>, a multimedia zine focusing on <I>Star Trek</I> and other science fiction, in 1978. After retiring the zine in 1996, Rogow published her first novel, <I>The Problem of the Missing Miss</I> (1998), which began the four-volume Charles Dodgson and Arthur Conan Doyle Mysteries.<BR /><BR /> Rogow&rsquo;s most recent novel is <I>Murders in Manatas</I> (2013). She is also a musician who has been playing sci-fi-inspired folk music since the 1970s.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Open Road Integrated Media
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?915e4fa4